import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { switchMap, map } from 'rxjs/operators';

export interface TicketComment {
  id: number;
  createDate: string;
  author: {
    username: string;
    name: string;
  };
  body: string;
  ticketId: number;
}

export interface TicketCommentDTO {
  id: number;
  createDate: string;
  authorName: string;
  body: string;
  ticketId: number;
}

export interface TicketCommentPage {
  _embedded: {
    ticketCommentDTOList: TicketCommentDTO[];
  };
  _links: any;
  page: {
    size: number;
    totalElements: number;
    totalPages: number;
    number: number;
  };
}

export interface CreateTicketCommentRequest {
  body: string;
}

@Injectable({
  providedIn: 'root'
})
export class TicketCommentService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getComments(ticketId: number, page: number = 0, size: number = 10): Observable<TicketCommentPage> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        return this.http.get<TicketCommentPage>(`${environment.apiUrl}/api/ticket-comments/ticket/${ticketId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            page: page.toString(),
            size: size.toString()
          }
        });
      })
    );
  }

  createComment(ticketId: number, request: CreateTicketCommentRequest): Observable<TicketCommentDTO> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        return this.http.post<TicketCommentDTO>(`${environment.apiUrl}/api/ticket-comments/ticket/${ticketId}`, request, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
      })
    );
  }

  deleteComment(commentId: number): Observable<void> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        return this.http.delete<void>(`${environment.apiUrl}/api/ticket-comments/${commentId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      })
    );
  }
}
